import axios from 'axios'

const HTTP = axios.create({
    baseURL: process.env.VUE_APP_API_URL
})

export default {
    // Zakazka
    getZakazka() {
        return HTTP.get('/Zakazka')
    },
    getZakazkaForProjektant(id) {
        return HTTP.get('/Zakazka/pid?id=' + id)
    },
    getZakazkaForUser(id) {
        return HTTP.get('/Zakazka/uid?id=' + id)
    },
    getZakazkaById(id) {
        return HTTP.get('/Zakazka/' + id)
    },
    postZakazka(value) {
        return HTTP.post('/Zakazka', value)
    },
    putZakazka(id, value) {
        return HTTP.put('/Zakazka/' + id, value)
    },
    deleteZakazka(id) {
        return HTTP.delete('/Zakazka/' + id)
    },
    
    // Podani
    getPodani() {
        return HTTP.get('/Podani')
    },
    getPodaniForUser(id, zid) {
        return HTTP.get('/Podani/uid?id=' + id + '&zid=' + zid)
    },
    getPodaniForProjektant(id, zid) {
        return HTTP.get('/Podani/pid?id=' + id + '&zid=' + zid)
    },
    getPodaniForZakazka(id) {
        return HTTP.get('/Podani/zid?id=' + id)
    },
    getPodaniById(id) {
        return HTTP.get('/Podani/' + id)
    },
    getDodatecnaPodani(id) {
        return HTTP.get('/Podani/dodatecna?id=' + id)
    },
    postPodani(value) {
        return HTTP.post('/Podani', value)
    },
    putPodani(id, value) {
        return HTTP.put('/Podani/' + id, value)
    },
    deletePodani(id) {
        return HTTP.delete('/Podani/' + id)
    },
    uploadFileForPodani(id, typ, file) {
        let formData = new FormData();
        formData.append('file', file);
        return HTTP.post('/Podani/upload?id=' + id + '&ext=' + file.name.split('.').pop() + '&typ=' + typ, formData, { headers: { 'Content-Type': 'multipart/form-data'}})
    },

    // Uzivatel
    getUzivatel() {
        return HTTP.get('/Uzivatel')
    },
    getUzivatelById(id) {
        return HTTP.get('/Uzivatel/' + id)
    },
    getUserByEmail(email) {
        return HTTP.get('/Uzivatel/email?email=' + email)
    },
    postUzivatel(value) {
        return HTTP.post('/Uzivatel', value)
    },
    putUzivatel(id, value) {
        return HTTP.put('/Uzivatel/' + id, value)
    },
    deleteUzivatel(id) {
        return HTTP.delete('/Uzivatel/' + id)
    },

    // Typ DOSS
    getTypDOSS() {
        return HTTP.get('/TypDOSS')
    },
    getTypDOSSById(id) {
        return HTTP.get('/TypDOSS/' + id)
    },
    postTypDOSS(value) {
        return HTTP.post('/TypDOSS', value)
    },
    putTypDOSS(id, value) {
        return HTTP.put('/TypDOSS/' + id, value)
    },
    deleteTypDOSS(id) {
        return HTTP.delete('/TypDOSS/' + id)
    },

    // DOSS
    getDOSS() {
        return HTTP.get('/DOSS')
    },
    getDOSSById(id) {
        return HTTP.get('/DOSS/' + id)
    },
    postDOSS(value) {
        return HTTP.post('/DOSS', value)
    },
    putDOSS(id, value) {
        return HTTP.put('/DOSS/' + id, value)
    },
    deleteDOSS(id) {
        return HTTP.delete('/DOSS/' + id)
    },

    // DOSS pracoviste
    getDOSSPrac() {
        return HTTP.get('/DOSSPrac')
    },
    getDOSSPracForDOSS(id) {
        return HTTP.get('/DOSSPrac/did?id=' + id)
    },
    getDOSSPracById(id) {
        return HTTP.get('/DOSSPrac/' + id)
    },
    postDOSSPrac(value) {
        return HTTP.post('/DOSSPrac', value)
    },
    putDOSSPrac(id, value) {
        return HTTP.put('/DOSSPrac/' + id, value)
    },
    deleteDOSSPrac(id) {
        return HTTP.delete('/DOSSPrac/' + id)
    },
    mergeDOSSPrac(id, ids) {
        return HTTP.put('/DOSSPrac/merge?id=' + id + '&ids=' + ids)
    },

    // Druh podani
    getDruhPodani() {
        return HTTP.get('/DruhPodani')
    },
    getDruhPodaniById(id) {
        return HTTP.get('/DruhPodani/' + id)
    },
    postDruhPodani(value) {
        return HTTP.post('/DruhPodani', value)
    },
    putDruhPodani(id, value) {
        return HTTP.put('/DruhPodani/' + id, value)
    },
    deleteDruhPodani(id) {
        return HTTP.delete('/DruhPodani/' + id)
    },

    // Druh stanoviska
    getDruhStanoviska() {
        return HTTP.get('/DruhStanoviska')
    },
    getDruhStanoviskaById(id) {
        return HTTP.get('/DruhStanoviska/' + id)
    },
    postDruhStanoviska(value) {
        return HTTP.post('/DruhStanoviska', value)
    },
    putDruhStanoviska(id, value) {
        return HTTP.put('/DruhStanoviska/' + id, value)
    },
    deleteDruhStanoviska(id) {
        return HTTP.delete('/DruhStanoviska/' + id)
    },

    // Status
    getStatus() {
        return HTTP.get('/Status')
    },
    getStatusById(id) {
        return HTTP.get('/Status/' + id)
    },
    postStatus(value) {
        return HTTP.post('/Status', value)
    },
    putStatus(id, value) {
        return HTTP.put('/Status/' + id, value)
    },
    deleteStatus(id) {
        return HTTP.delete('/Status/' + id)
    }
}